import React, { useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Typography, Row, Col, Input } from "antd";

//
import log from "../../utils/log";
import c from "../../utils/common";
import moment from "moment-timezone";
import metaData from "../../data/metaData";
import _ from "lodash";
import { showErrMsg } from "../../utils/error";

//
import ShopProfile from "../ShopProfile";
import BrandProfile from "../BrandProfile";
import CompanyProfile from "../CompanyProfile";

const RequestDetailView = ({ state = {}, shopForm, brandForm, companyForm }) => {
  const { data, form, onChange } = state;
  let { company, brand } = c.getBrandAndCompanyFromRequest(data);

  return (
    <Row justify="space-evenly" style={{ width: "100%", margin: "1rem 0 5rem 0" }}>
      <Col span={12}>
        <ShopProfile
          state={{
            data: data?.info?.shop,
            form: shopForm,
            onChange: onChange,
          }}
          brand={brand}
          readOnly={true} // Explicitly set to true for read-only mode
        />
      </Col>

      <Col span={11}>
        <BrandProfile
          state={{
            data: brand,
            form: brandForm,
            onChange: onChange,
          }}
          readOnly={true} // Explicitly set to true for read-only mode
        />
        <CompanyProfile
          state={{
            data: company,
            form: companyForm,
            onChange: onChange,
          }}
          readOnly={true} // Explicitly set to true for read-only mode
          requestStatus={data?.status}
        />
      </Col>
    </Row>
  );
};

export default RequestDetailView;
